/*
    * Fisher Analytics
    * This script initializes the Fisher Analytics module and sets up the necessary configurations.
    * It defines the version, URL patterns, and the methods to be called for each URL pattern.
    * when adding new urlPatterns, make sure to add the corresponding method and responseText in the urlConfig object.
 */
window.fisherAnalytics = {
    timestamp: "2025-11-14T14:19:59.273Z",
    backendLoggingEnabled: document.location.host.indexOf('www') === -1,
    localStorageLoggingKey: 'fisherAnalyticsLogging',
    version: '1.0.0',
    urlPatterns: ['/addToCartService',
        '/addMultipleToCartService',
        '/cart/shippingandtax',
        '/cart/updatecart',
        '/cart/deleteitem',
        '/saveforlater/movetocart',
        '/saveforlater/save',
        '/quotes/api/cart/add',
        '/accountdropdown',
        '/profiles/current',
        '/store1/mylist/service/createList',
        '/store1/mylist/service/addtolist/createlist/items/NEW_MYLIST',
        '/store1/mylist/service/addtolist/items/',
        '/store1/mylist/service/item/',
        '/store1/mylist/service/listItems/',
        '/store1/mylist/service/importItems/',
        '/store1/mylist/service/share/',
        '/claim',
        '/shop/jsoncartlet',
        '/shop/additemstocart',
        '/cart/service/minifiedcart',
        '/store1/cart/generatewebquote/',
        '/store1/quotes/api/quote/new',
        '/store1/quotes/service/eloqua/',
        '/shop/login/login'
    ],
    urlConfig: {
        '/shop/jsoncartlet': {
            method: ['window.fisherAnalytics.legacyCart.processLegacyCart'],
            responseText: 'basketitems'
        },
        '/shop/additemstocart': {
            method: ['window.fisherAnalytics.legacyCart.processLegacyFindingMethod'],
            responseText: '"wasAdded":true'
        },
        '/addToCartService': {
            method: ['window.fisherAnalytics.cart.process'],
            responseText: 'wasAdded'
        },
        '/addMultipleToCartService': {
            method: ['window.fisherAnalytics.cart.process'],
            responseText: '"wasAdded":true'
        },
        '/cart/shippingandtax': {
            method: ['window.fisherAnalytics.cart.process'],
            responseText: 'wasAdded'
        },
        '/cart/updatecart': {
            method: ['window.fisherAnalytics.cart.process'],
            responseText: 'wasAdded',
            updateItem: true
        },
        '/cart/deleteitem': {
            method: ['window.fisherAnalytics.cart.process'],
            responseText: 'wasAdded',
            deleteItem: true
        },
        '/saveforlater/movetocart': {
            method: ['window.fisherAnalytics.cart.process'],
            responseText: '"wasAdded":true',
            moveToCart: true
        },
        '/saveforlater/save': {
            method: ['window.fisherAnalytics.cart.process'],
            responseText: 'wasAdded',
            saveForLater: true
        },
        '/quotes/api/cart/add': {
            method: ['window.fisherAnalytics.cart.process'],
            responseText: '"wasAdded":true'
        },
        '/cart/service/minifiedcart': {
            method: ['window.fisherAnalytics.cart.process'],
            responseText: 'wasAdded'
        },
        '/accountdropdown': {
            method: ['window.fisherAnalytics.users.process','window.fisherAnalytics.cart.callMinifiedCart'],
            responseText: 'var accountDropdown',
            options:{
                useLegacy: false
            }
        },
        '/profiles/current': {
            method: [
                'window.fisherAnalytics.users.process'
            ],
            responseText: '"userType":',
            options: {
                useLegacy: true
            }
        },
        '/store1/mylist/service/createList': {
            method: [
                'window.fisherAnalytics.myList.processCreateListFromMyListPage'
            ],
            responseText: 'CREATE_LIST_SUCCESS',
            notes: 'This is for creating a potentially empty list from the My Lists page'
        },
        '/store1/mylist/service/addtolist/createlist/items/NEW_MYLIST': {
            method: [
                'window.fisherAnalytics.myList.processCreateList'
            ],
            responseText: 'CREATE_LIST_SUCCESS',
            notes: 'This is for creating a new list when adding an item to a new list from a product, search etc'
        },
        '/store1/mylist/service/addtolist/items/': {
            method: [
                'window.fisherAnalytics.myList.processAddToList'
            ],
            responseText: ''
        },
        '/store1/mylist/service/item/':{
            method: [
                'window.fisherAnalytics.myList.processRemoveItemFromList'
            ],
            responseText: 'DELETE_ITEM_SUCCESS'
        },
        '/store1/mylist/service/listItems/':{
            method: [
                'window.fisherAnalytics.myList.processBulkUploadToList'
            ],
            responseText: '"listId"'
        },'/store1/mylist/service/importItems/':{
            method: [
                'window.fisherAnalytics.myList.setBulkUploadListFlag'
            ],
            responseText: '"IMPORT_SKU_SUCCESS"'
        },
        '/store1/mylist/service/share/':{
            method: [
                'window.fisherAnalytics.myList.processAcceptShareList'
            ],
            responseText: 'List successfully shared'
        },
        '/claim':{
            method: [
                'window.fisherAnalytics.myList.processAcceptShareList'
            ],
            responseText: 'isOriginalOwner'
        },
        '/signin.html': {
            method: [
                'window.fisherAnalytics.users.loginInitiated'
            ],
            responseText: 'loginOverlayContent'
        },
        '/shop/login/login': {
            method: [
                'window.fisherAnalytics.users.login'
            ],
            responseText: 'loginSuccess',
            pauseExecution: 1000
        },
        '/store1/cart/generatewebquote/': {
            method: [
                'window.fisherAnalytics.quotes.processGenerateWebQuote'
            ],
            quoteType: 'Instant',
            responseText: '"quoteNumber":'
        },
        '/store1/quotes/api/quote/new': {
            method: [
                'window.fisherAnalytics.quotes.processRequestWebQuote'
            ],
            responseText: '"quoteNumber":'
        },
        '/store1/quotes/service/eloqua/': {
            method: [
                'window.fisherAnalytics.quotes.processGenerateWebQuote'
            ],
            quoteType: 'Custom',
            responseText: 'successfully sent to eloqua service'
        }
    }
};